import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Il cambio pagina deve sempre mostrare la nuova vista dall'inizio: senza questo
// lo scroll resta all'offset della pagina precedente (es. si atterra a meta'
// della pagina /download essendo partiti dalla landing scorsa in basso).
// Con un hash (#sezione) si lascia gestire l'ancora al browser.
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
